import m from 'moment';

export const isTimestampValid = (t) => m(t).isValid();

export const convertDurationToRange = (d) => {
  const now = m();
  const until = now.unix();

  if (d === 'all') {
    return [];
  }

  if (d === 'ytd') {
    const since = now.clone().startOf('year').unix();

    return [since, until];
  }

  const since = now.clone().subtract(d, 'd').unix();

  return [since, until];
};

export const currentUnixTimestamp = () => {
  const time = m().unix();

  return time;
};

export const currentUnixTimestampMs = () => {
  return currentUnixTimestamp() * 1000;
};
